const Backbone = require('backbone')
const $ = require('jquery')

const APP = require('APP')
const win = require('Helpers/win')
const ajax = require('ajax')
const { isIphone } = require('Helpers/device')
const killEvent = require('Helpers/killEvent')
const router = require('router')
const MandatoryLimitTimer = require('Views/GamePlay/MandatoryLimitTimer')
const GamePlayMessagesView = require('Views/GamePlay/GamePlayMessagesView')
const GameLimitsView = require('Views/GamePlay/GameLimits')
const playContainerTpl = require('../../Block/play_container.html.twig')
const user = require('Models/UserModel')
const WakeLockService = require('utils/wakeLockService').default
const PlayForRealAlert = require('./PlayForRealAlert').default

module.exports = Backbone.View.extend({
  className: 'game-play-overlay',
  templateName: 'gamePlayContainerTemplate',
  aspectRatio: 1024 / 640,

  events: {
    'click #gamePlayFullscreenBtn': 'fullscreen',
    'click #gamePlayBackBtn': 'destroy',
    'click #gamePlayHelpBtn': 'openHelp',
    'click #makeDepositBtn': 'makeDeposit',
    'click #panicButtonBtn': 'panicButton',
    'click #realGameButton': 'redirectToRealGame',
  },

  initialize(options) {
    this.forFun = options.forFun
    this.gameModel = options.gameModel
    this.render()
    this.wakeLock = new WakeLockService()

    this.messages = new GamePlayMessagesView(this, options.gameModel, options.forFun)

    if (!this.canRunGame()) {
      return
    }

    if (this.forFun) {
      const playForRealAlert = new PlayForRealAlert({
        threshold: APP.askPlayForRealThresholdInMinutes,
        messages: this.messages,
      })

      playForRealAlert.start()
    }

    this.preventScreenToSleep()
    // desktop chrome / ff / android chrome
    window.addEventListener('beforeunload', () => {
      this.sendFinish(() => {})
    })
    // mobile android / iOS
    window.addEventListener('unload', () => {
      this.sendFinish(() => {})
    })
    // iOS
    window.addEventListener('pagehide', () => {
      this.sendFinish(() => {})
    })

    if (this.gameModel.get('isExternal')) {
      /** getting iframe url to load iframe (external game) */
      if (!APP.iframe) {
        ajax.getJson(
          [
            'game_play',
            {
              slug: this.gameModel.get('slug'),
              forFun: this.forFun,
            },
          ],
          this.renderIframe.bind(this),
          (e) => {
            killEvent(e)
          },
        )
      } else {
        this.renderIframe({ data: { iframeUrl: APP.iframe } })
      }
    } else {
      alert('something went wrong')
    }
  },

  onPlayForReal() {
    clearTimeout(this.updateNetLossTOID)
    if (this.timer) {
      this.updateNetLossTOID = setTimeout(() => {
        ajax.getJson(['multilotto_user_limit_info'], (data) => {
          if (data.data.mandatoryLimitValue !== undefined) {
            this.timer.setLimitValue(data.data.mandatoryLimitValue)
          }
        })
      }, 500)
    }
  },

  onInitCompleted() {
    if (this.timer) {
      this.timer.updateSyncTime()
      this.timer.update()
    }
  },

  /**
   * checking if user can play for real - if not displaying messages
   */
  canRunGame() {
    if (this.forFun === true || this.forFun === '1') {
      if (!user.config.isLogged && user.config.forFunRegistrationReq) {
        this.messages.showNeedFastRegistrationDialog()
        return false
      }
    } else if (!user.config.isLogged) {
      this.messages.showRealPlayNotLoggedDialog()
      return false
    } else if (!this.gameModel.get('isRealPlayPermitted')) {
      this.messages.showRealPlayNotPermittedDialog()
      return false
    } else if (APP.isPlayPermittedErrorMessage) {
      this.messages.showRealPlayNotPermittedDialog()
      return false
    } else if (user.config.isForFunUser === true) {
      this.messages.showRealPlayNotPermittedForFunPlayerDialog()
      return false
    } else if (user.config.credits <= 0) {
      this.messages.showNoCreditsDialog()
      return false
    }

    return true
  },

  render() {
    const tpl = playContainerTpl({
      // noHeader: !!APP.isCapi,
      noHeader: false,
      user: user.config,
      displayHazardAddictionInfo: APP.displayHazardAddictionInfo,
      legislation: APP.legislation,
      fullscreenEnabled: win.isFullscreenEnabled(),
      isMobile: MOBILE,
      isForFun: this.forFun,
    })
    this.setElement(tpl)

    this.$el.appendTo('body')
    this.fsOpen = this.el.querySelector('#gamePlayFullscreenBtn .fs-open')
    this.fsClose = this.el.querySelector('#gamePlayFullscreenBtn .fs-close')
    this.qhOpen = this.el.querySelector('#gamePlayHelpBtn svg')
    this.playHeader = this.el.querySelector('.game-play-header')

    if (!this.forFun) {
      if (!APP.isCapi && user.config.mandatoryLimitValue !== undefined) {
        this.timer = new MandatoryLimitTimer(document.getElementById('gamePlayClock'), {
          mandatoryLimitValue: user.config.mandatoryLimitValue,
          mandatoryLimitThreshold: 120,
        })
      }
    }

    this.hidePage()
    this.onResize()
    this.listenTo(win, 'resize', this.onResize)

    this.gameLimits = GameLimitsView(
      document.getElementById('gamePlayLimits'),
      APP.gameLimitsConfiguration,
      user.config.isLogged,
      this.forFun,
      APP.gameLimitsSyncInterval,
    )
  },

  renderIframe(response) {
    this.iframeUrl = response.data.iframeUrl
    this.iframe = document.createElement('object')
    if (this.iframe.data === '') {
      /* object element is supported */

      this.iframe.setAttribute('data', this.iframeUrl)
      this.iframe.className = 'game-play-box'
    } else {
      /* use old iframe if object element is not supported */

      this.iframe = document.createElement('iframe')
      this.iframe.setAttribute('src', this.iframeUrl)
      this.iframe.className = 'game-play-box'
    }

    this.$el.append(this.iframe)

    setTimeout(this.focusIframe.bind(this), 1000)

    this.onResize()

    win.$html.css('overflow-y', 'hidden')

    window.addEventListener(
      'message',
      (event) => {
        try {
          if (event.data) {
            if (this.shouldFocusIframe(event.data)) {
              this.focusIframe()
            } else if (this.shouldDestroy(event.data)) {
              this.destroy()
            } else if (this.shouldReload(event.data)) {
              window.location.reload()
            }
          }
        } catch (e) {
          console.error(e)
        }
      },
      false,
    )

    if (isIphone()) {
      console.log('window.scrollTop', window.scrollTop)
      window.scrollTop = 0
    }
  },

  shouldFocusIframe(data) {
    return data === 'focusIframe'
  },

  shouldDestroy(data) {
    return (
      data === 'closeGame' ||
      (data.command && data.command === 'com.egt-bg.exit') || // Amusnet exit
      (data.command && data.command === 'exit') || // EGT Digital exit
      (data.name && ['gameQuit', 'notifyCloseContainer'].includes(data.name))
    ) // Pragmatic exit
  },

  shouldReload(data) {
    return data.command && data.command === 'com.egt-bg.reload' // Amusnet reload
  },

  focusIframe() {
    this.iframe?.contentWindow?.focus?.()
  },

  showPage() {
    win.fullscreen(false)
    win.$wrapper.show()
    try {
      win.$html.css('overflow-y', '')
    } catch (e) {
      console.error(e)
    }

    if (APP.quickHelp) {
      APP.quickHelp.showBtn()
    }
  },

  hidePage() {
    win.$wrapper.hide()

    try {
      win.$html.css('overflow-y', 'hidden')
    } catch (e) {
      console.error(e)
    }

    if (APP.quickHelp) {
      APP.quickHelp.hideBtn()
    }
  },

  fullscreen() {
    return win.fullscreen()
  },

  show() {
    if (this.isDestroyed === true) {
      return
    }
    // this.$el.css('visibility', 'visible');

    win.$html.css('overflow-y', 'hidden')
    win.setSelectable(false)
    this.showGame()
  },

  hide() {
    // this.$el.css('visibility', 'hidden');
    if (this.fixer) {
      this.fixer.css('visibility', 'hidden')
    }

    win.$html.css('overflow-y', '')
    win.setSelectable(true)
    this.hideGame()
  },

  showGame() {
    if (this.gamePlayView && this.gamePlayView.show) {
      this.gamePlayView.show()
    } else if (this.iframe) {
      this.iframe.style.visibility = 'inherit'
    }
  },

  hideGame() {
    if (this.gamePlayView && this.gamePlayView.hide) {
      this.gamePlayView.hide()
    } else if (this.iframe) {
      this.iframe.style.visibility = 'hidden'
    }
  },

  makeDeposit(e) {
    this.destroy(e, () => {
      const href = this.$el.find('#makeDepositBtn').attr('href')
      if (href) {
        router.redirect(href)
      }
    })
  },

  panicButton(e) {
    killEvent(e)

    this.messages.showPanicButtonAlert(() => {
      this.destroy(e, () => {
        const href = this.$el.find('#panicButtonBtn').attr('href')

        if (href) {
          router.redirect(href)
        }
      })
    })
  },

  redirectToRealGame(e) {
    this.destroy(e, () => {
      const href = this.gameModel.get('realPlayUrl')

      router.redirect(href)
    })
  },

  destroy(e, callback) {
    killEvent(e)
    if (!this.isDestroyed) {
      this.isDestroyed = true
      let toTime = 1

      callback =
        callback ||
        (() => {
          this.showPage()

          if (this.gamePlayView) {
            this.gamePlayView.destroy()
            this.gamePlayView = undefined
          }

          if (this.fixer) {
            this.fixer.remove()
            this.fixer = undefined
          }

          this.trigger('destroy')
          this.remove()
        })

      if (this.iframe) {
        toTime = 5000

        this.sendFinish(callback)
      }

      if (this.gameLimits) {
        this.gameLimits.remove()
      }

      setTimeout(() => {
        callback()
      }, toTime)
    }
  },

  sendFinish(callback) {
    if (this.closeMsgSend) {
      return
    }

    console.log('SENDING FINISH !!!')

    this.closeMsgSend = true
    const url =
      APP.closeUrl ||
      router.path('game_server_game_client_finish', {
        gameId: this.gameModel.get('number'),
        forFun: this.forFun,
      })
    ajax.ajax(url, {
      always() {
        callback()
      },
    })
  },

  onResize() {
    // console.log('game on resize');
    this.el.style.width = `${win.width}px`
    this.el.style.height = `${win.height}px`

    let havVerticalHeader = false
    if (win.height * this.aspectRatio > win.width - 100) {
      this.playHeader.classList.remove('game-play-header-mobile-left')
    } else if (MOBILE) {
      havVerticalHeader = true
      this.playHeader.classList.add('game-play-header-mobile-left')
    }

    if (this.iframe) {
      if (havVerticalHeader) {
        const playHeaderWidth = this.playHeader ? this.playHeader.offsetWidth : 0

        this.iframe.style.width = `${this.el.clientWidth - playHeaderWidth}px`
        this.iframe.style.height = `${this.el.clientHeight}px`
        this.iframe.style.top = 0
        this.iframe.style.left = `${playHeaderWidth}px`
      } else {
        const playHeaderHeight = this.playHeader ? this.playHeader.offsetHeight : 0

        this.iframe.style.width = `${this.el.clientWidth}px`
        this.iframe.style.height = `${this.el.clientHeight - playHeaderHeight}px`
        this.iframe.style.top = `${playHeaderHeight}px`
        this.iframe.style.left = 0
      }
    }

    if (this.fsOpen && this.fsClose) {
      if (win.isFullscreen()) {
        this.fsOpen.style.display = 'none'
        this.fsClose.style.display = ''
      } else {
        this.fsOpen.style.display = ''
        this.fsClose.style.display = 'none'
      }
    }

    window.scrollTo(0, 0)
  },

  openHelp() {
    this.qhOpen.style.display = 'none'
    $(this.qhOpen.parentNode).addLoader(1)

    APP.quickHelp.on(APP.quickHelp.EVENT_OPEN, () => {
      this.qhOpen.style.display = ''
      $(this.qhOpen.parentNode).removeLoader()
    })

    APP.quickHelp.open()
  },

  async preventScreenToSleep() {
    /** @type WakeLockService */
    const wakeLock = this.wakeLock
    await wakeLock.lockScreen()
  },
})
